<form class="file-upload-button">
  <input type="file" name="files" id="file-input" multiple (change)="onFileBrowse($event)"
         [accept]="FileUtils.getAllowedFileExtensions()" />
  <label for="file-input" class="iese-rounded-button secondary" pTooltip="Upload or drag your own file(s)"
         tooltipPosition="top">
    <span class="pi pi-plus"></span>
  </label>
</form>
